import {
  SET_DIRECTIONS,
  SET_DIRECTION_FLAG,
} from '../actions/types/PostalOperatorActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import DirectionTypes from '../../../../common/redux/actions/types/DirectionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = {
  defaultDirection: DirectionTypes.INBOUND,
  directionSwitchEnabled: true,
  switched: false,
};

export const directionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ENTERED_WIZARD:
      return initialState;
    case SET_DIRECTIONS:
      return {
        ...state,
        defaultDirection: action.payload.directions[0],
        directionSwitchEnabled: action.payload.directions.length > 1,
      };
    case SET_DIRECTION_FLAG:
      return {
        ...state,
        switched: action.payload.switched,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
